<template>
    <router-link
        class="event-link"
        :to="{ name: 'EventDetails', params: { id: event.id, apihost: apihost, city: city } }"
    >
        <v-card outlined tile class="event-card" @click="$emit('show_event', event.id)">
            <v-img
                :src="event.img"
                height="150px"
            ></v-img>
            <v-card-title class="text-h6" style="word-break: break-word">
                {{ event.title[$i18n.locale] }}
            </v-card-title>
            <v-card-subtitle>{{ event.date.locale($i18n.locale).format('YYYY-MM-DD HH:00') }}</v-card-subtitle>
            <v-overlay :value="lock" :absolute=true>
            </v-overlay>
        </v-card>
    </router-link>
</template>

<script>
export default {
    props: {
        apihost: String,
        city: String,
        lock: Boolean,
        event: {
            id: String,
            date: String,
            title: Object,
            img: String
        }
    }
}
</script>

<style scoped>
.event-card {
  cursor: pointer;
  margin-bottom: 10px;
}

.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2);
}

.event-link {
  color: #2c3e50;
  text-decoration: none;
}
</style>


